(() => {
  if (window.sipAgeCheckLoaded) return;
  window.sipAgeCheckLoaded = true;

  let confirmed = false;
  let pendingForm = null;

  const modal = document.createElement('div');
  modal.id = 'sip-cart-age-modal';
  modal.hidden = true;

  modal.innerHTML = `
    <div class="sip-cart-age-box" role="dialog"
         aria-modal="true" aria-labelledby="sip-cart-age-title">
      <div class="sip-cart-age-number">18+</div>
      <h2 id="sip-cart-age-title">ALTERSBESTÄTIGUNG</h2>
      <p>Dieses Produkt enthält Alkohol.<br>
         Bist du mindestens 18 Jahre alt?</p>
      <button type="button" id="sip-cart-age-yes">
        JA, ICH BIN MINDESTENS 18
      </button>
      <button type="button" id="sip-cart-age-no">
        NEIN, ICH BIN UNTER 18
      </button>
      <small>Bei der Lieferung wird ein amtlicher
        Ausweis kontrolliert.</small>
    </div>
  `;

  const style = document.createElement('style');
  style.textContent = `
    #sip-cart-age-modal[hidden] { display: none !important; }
    #sip-cart-age-modal {
      position: fixed;
      inset: 0;
      z-index: 2147483647;
      background: rgba(0,0,0,.94);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
    }
    .sip-cart-age-box {
      width: 100%;
      max-width: 460px;
      padding: 32px 24px;
      background: #171717;
      border: 2px solid #e8c36b;
      border-radius: 14px;
      text-align: center;
      color: white;
    }
    .sip-cart-age-number {
      color: #e8c36b;
      font-size: 52px;
      font-weight: 800;
    }
    .sip-cart-age-box h2 {
      color: #e8c36b;
      font-size: 24px;
    }
    .sip-cart-age-box p {
      font-size: 16px;
      line-height: 1.6;
    }
    .sip-cart-age-box button {
      display: block;
      width: 100%;
      padding: 15px 10px;
      margin-top: 12px;
      border-radius: 6px;
      font-weight: 800;
      cursor: pointer;
    }
    #sip-cart-age-yes {
      background: #e8c36b;
      border: 2px solid #e8c36b;
      color: #111;
    }
    #sip-cart-age-no {
      background: transparent;
      border: 2px solid #e8c36b;
      color: #e8c36b;
    }
    .sip-cart-age-box small {
      display: block;
      margin-top: 20px;
      color: #aaa;
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(modal);

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const button = form.querySelector(
      '[data-sip-age-required="true"]'
    );

    if (!button || confirmed) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    pendingForm = form;
    modal.hidden = false;
    document.getElementById('sip-cart-age-yes').focus();
  }, true);

  document.getElementById('sip-cart-age-yes')
    .addEventListener('click', () => {
      confirmed = true;
      modal.hidden = true;

      if (pendingForm) {
        const form = pendingForm;
        pendingForm = null;
        form.requestSubmit();
      }
    });

  document.getElementById('sip-cart-age-no')
    .addEventListener('click', () => {
      modal.hidden = true;
      pendingForm = null;
    });
})();
